module.exports = __webpack_public_path__ + "img/swiper7.9c0b9399.jpg";